import { transport } from 'config/transport';

export function callApiGetListOfChiMamNon(congDoanId, month, year) {
    return transport.get(`/mamnon/${congDoanId}/thuchi/chimamnon`, { params: { month, year } });
}
